import api from './api';

// const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';
const BASE_URL = `/dependencies`;

const dependencyService = {
  // Get all dependencies with filters
  getAll: async (params = {}) => {
    try {
      const response = await api.get(BASE_URL, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get dependency by ID
  getById: async (id) => {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Create new dependency
  create: async (dependencyData) => {
    try {
      const response = await api.post(BASE_URL, dependencyData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Update dependency
  update: async (id, dependencyData) => {
    try {
      const response = await api.put(`${BASE_URL}/${id}`, dependencyData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Delete dependency
  delete: async (id) => {
    try {
      const response = await api.delete(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get dependencies by project
  getByProject: async (projectId) => {
    try {
      const response = await api.get(`${BASE_URL}/project/${projectId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get dependencies by task
  getByTask: async (taskId) => {
    try {
      const response = await api.get(`${BASE_URL}/task/${taskId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Resolve dependency
  resolve: async (id, resolutionNotes) => {
    try {
      const response = await api.put(`${BASE_URL}/${id}/resolve`, {
        resolution_notes: resolutionNotes
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get dependency statistics
  getStats: async (projectId = null) => {
    try {
      const params = projectId ? { project_id: projectId } : {};
      const response = await api.get(`${BASE_URL}/stats`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default dependencyService;